import clsx from 'clsx';
import styles from './Flex.module.scss';

import { type ReactNode } from 'react';

interface Props {
  align?: 'start' | 'center' | 'end';
  children: ReactNode;
  direction?: 'column' | 'row';
  gap?: 'none' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  wrap?: 'none' | 'auto';
}

export function Flex({
  children,
  direction = 'row',
  gap = 'none',
  wrap = 'none',
  align = 'start',
}: Props) {
  return (
    <div
      className={clsx(
        styles['flex'],
        styles[`flex-align-${align}`],
        styles[`flex-direction-${direction}`],
        styles[`flex-gap-${gap}`],
        styles[`flex-wrap-${wrap}`],
      )}
    >
      {children}
    </div>
  );
}
